/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { authManager } from './authManager';

const apiHost = process.env.REACT_APP_API_URL;
const axiosServices = axios.create({ baseURL: apiHost });

axiosServices.interceptors.request.use(
    (config) => {
        const token = authManager.getToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
